export const MODAL_TITLE = `「一覧に戻る」を\n押下すると入力した内容が\n全てリセットされます。`

export const BACK_BUTTON = 'もどる'
export const AGREE_BUTTON = '一覧に戻る'
export const CHANCEL_BUTTON = 'キャンセル'
